import { render, staticRenderFns } from "./RowBlock.vue?vue&type=template&id=c2b0ba7e&"
import script from "./RowBlock.vue?vue&type=script&lang=js&"
export * from "./RowBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports